export const COLORS = {
  NEUTRAL: 'neutral',
  BROWN: 'brown',
  CITRINE: 'citrine',
  AMBER: 'amber',
  ORANGE: 'orange',
  LIME: 'lime',
  GREEN: 'green',
  GRASS: 'grass',
  SKY: 'sky',
  EMERALD: 'emerald',
  BLUE: 'blue',
  PURPLE: 'purple',
  FUCHSIA: 'fuchsia',
  RED: 'red',
  MAGENTA: 'magenta',
} as const;

export const COLORS_KEYS = Object.keys(COLORS) as (keyof typeof COLORS)[];
